import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { useAddOnsSearch } from './AddOnsSearchContext';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const AddOnsSearchFilter = () => {
  const {
    searchTerm,
    setSearchTerm
  } = useAddOnsSearch();
  const handleChange = event => {
    setSearchTerm(event.target.value);
  };
  return /*#__PURE__*/_jsx(SearchInput, {
    value: searchTerm,
    onChange: handleChange,
    placeholder: I18n.text('pricingPage.pages.addOns.search.placeholder'),
    marginBlockEnd: "400"
  });
};
export default AddOnsSearchFilter;